"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
var core_1 = require("@material-ui/core");
var ExpandLess_1 = __importDefault(require("@material-ui/icons/ExpandLess"));
var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
var prop_types_1 = __importDefault(require("prop-types"));
var getAccountTree_1 = __importDefault(require("./getAccountTree"));
var AccountTree = /** @class */ (function (_super) {
    __extends(AccountTree, _super);
    function AccountTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            childData: null,
            loadState: "new",
            collapsed: []
        };
        _this.componentDidMount = function () {
            _this.setState({ loadState: "loading" });
            getAccountTree_1.default(_this.props.searchClientId, process.env.NODE_ENV === "development")
                .then(function (childResponse) {
                console.debug(childResponse.response);
                _this.setState({
                    childData: childResponse.status === "success" ? [childResponse.data] : null,
                    loadState: "loaded"
                }, function () { return console.debug(_this.state); });
            })
                .catch(function () {
                return _this.setState({
                    loadState: "error"
                });
            });
        };
        _this.collapse = function (accountId) {
            _this.setState({ collapsed: __spreadArray(__spreadArray([], _this.state.collapsed), [accountId]) });
        };
        _this.expand = function (accountId) {
            _this.setState({
                collapsed: __spreadArray([], _this.state.collapsed.filter(function (item) { return item !== accountId; }))
            });
        };
        _this.showAccount = function (account) {
            if ((account.name + " (" + account.id + ")")
                .toLowerCase()
                .indexOf(_this.props.filterString.toLowerCase()) > -1)
                return true;
            return (account.children || []).some(_this.showAccount);
        };
        _this.displayChildTree = function (accountList) {
            return (accountList &&
                accountList
                    .filter(function (account) {
                    return _this.props.filterString ? _this.showAccount(account) : true;
                })
                    .map(function (account, idx) {
                    var selectedClient = _this.props.targetClientId != null
                        ? account.id === _this.props.targetClientId
                        : Number(_this.props.selectedClientId) === account.id;
                    return (react_1.default.createElement(core_1.List, { style: { paddingLeft: "2em" }, dense: true, key: idx },
                        react_1.default.createElement(core_1.ListItem, { button: true, dense: true, selected: selectedClient, onClick: function () { return _this.props.accountClick(account.id); } },
                            account.children &&
                                (!_this.state.collapsed.includes(account.id) ? (react_1.default.createElement(ExpandLess_1.default, { onClick: function () { return _this.collapse(account.id); }, style: { marginRight: "6px" } })) : (react_1.default.createElement(ExpandMore_1.default, { onClick: function () { return _this.expand(account.id); }, style: { marginRight: "6px" } }))),
                            react_1.default.createElement(core_1.ListItemText, { primary: account.name + " (" + account.id + ")", style: account.children ? {} : { marginLeft: "30px" } })),
                        react_1.default.createElement(core_1.Collapse, { in: !_this.state.collapsed.includes(account.id) }, account.children
                            ? _this.displayChildTree(account.children)
                            : null)));
                }));
        };
        _this.render = function () {
            switch (_this.state.loadState) {
                case "loaded":
                    return _this.displayChildTree(_this.state.childData);
                case "error":
                    return (react_1.default.createElement("p", null, "Unable to load account tree, please refresh and try again."));
                case "new":
                case "loading":
                default:
                    return (react_1.default.createElement(core_1.Grid, { container: true, justifyContent: "center" },
                        react_1.default.createElement(core_1.Grid, { item: true },
                            react_1.default.createElement(CircularProgress_1.default, null))));
            }
        };
        return _this;
    }
    return AccountTree;
}(react_1.default.Component));
AccountTree.propTypes = {
    searchClientId: prop_types_1.default.string,
    selectedClientId: prop_types_1.default.string,
    targetClientId: prop_types_1.default.string,
    accountClick: prop_types_1.default.func,
    filterString: prop_types_1.default.string
};
exports.default = AccountTree;
